(() => {
  'use strict';
  if (customElements.get('max-rive-stories')) return;
  class MaxRiveStories extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = Array.from(this.querySelectorAll('[data-mrs-slide]'));
      if (!this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.viewport = this.querySelector('[data-mrs-viewport]');
      this.counter = this.querySelector('[data-mrs-current]');
      this.progress = this.querySelector('[data-mrs-progress]');
      this.announcement = this.querySelector('[data-mrs-announcement]');
      // Remove empty editor paragraphs and edge line breaks without changing the review words.
      this.querySelectorAll('.mrs-review p').forEach(paragraph => {
        if (!paragraph.textContent.trim() && !paragraph.querySelector('img')) { paragraph.remove(); return; }
        while (paragraph.firstChild && (paragraph.firstChild.nodeName === 'BR' || (paragraph.firstChild.nodeType === 3 && !paragraph.firstChild.textContent.trim()))) paragraph.firstChild.remove();
        while (paragraph.lastChild && (paragraph.lastChild.nodeName === 'BR' || (paragraph.lastChild.nodeType === 3 && !paragraph.lastChild.textContent.trim()))) paragraph.lastChild.remove();
      });
      this.querySelector('[data-mrs-prev]')?.addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-mrs-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
      this.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.viewport.addEventListener('touchstart', event => {
        const touch = event.touches[0];
        this.touch = event.touches.length === 1 ? { x: touch.clientX, y: touch.clientY } : null;
      }, { ...options, passive: true });
      this.viewport.addEventListener('touchend', event => {
        if (!this.touch) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - this.touch.x;
        const dy = touch.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
      }, { ...options, passive: true });
      this.viewport.addEventListener('touchcancel', () => { this.touch = null; }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index !== -1) this.show(index, false);
      }, options);
      // Below-the-fold reviews must not eagerly fetch three large photographs
      // during the initial page load. Native lazy loading remains the fallback.
      this.imagesReady = !!window.Shopify?.designMode || !('IntersectionObserver' in window);
      if (!this.imagesReady) {
        this.imageObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.imagesReady = true;
          this.imageObserver.disconnect();
          this.loadImages(false);
        }, { rootMargin: '300px 0px' });
        this.imageObserver.observe(this);
      }
      this.show(0, false);
    }
    show(index, announce = true) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const selected = i === this.index;
        slide.hidden = !selected;
        slide.classList.remove('mrs-enter');
        if (selected && announce) { void slide.offsetWidth; slide.classList.add('mrs-enter'); }
      });
      if (this.counter) this.counter.textContent = String(this.index + 1).padStart(2, '0');
      if (this.progress) this.progress.style.width = `${((this.index + 1) / this.slides.length) * 100}%`;
      if (announce && this.announcement) this.announcement.textContent = `Review ${this.index + 1} of ${this.slides.length}: ${this.slides[this.index].dataset.name}.`;
      if (this.imagesReady || announce || window.Shopify?.designMode) this.loadImages(announce);
    }
    loadImages(includeNeighbours) {
      const indices = includeNeighbours
        ? [this.index, (this.index + 1) % this.slides.length, (this.index - 1 + this.slides.length) % this.slides.length]
        : [this.index];
      indices.forEach(i => {
        this.slides[i].querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.imageObserver?.disconnect();
      this.controller = null;
      this.touch = null;
    }
  }
  customElements.define('max-rive-stories', MaxRiveStories);
})();
